import { ESocialNetworks, EIconType } from '@common/enums';

export const ICON_NAMES = [
    ESocialNetworks.facebook,
    ESocialNetworks.twitter,
    ESocialNetworks.telegram,
    ESocialNetworks.tiktok,
    ESocialNetworks.instagram,
    ESocialNetworks.youtube,
    ESocialNetworks.linkedin,
    ESocialNetworks.messenger,
    ESocialNetworks.viber,
    ESocialNetworks.whatsapp,
    ESocialNetworks.pinterest,
    ESocialNetworks.medium,
    ESocialNetworks.spotify,
    ESocialNetworks.slideshare,
    ESocialNetworks.tumblr,
    ESocialNetworks.twitch,
    ESocialNetworks.vimeo,
    ESocialNetworks.snapchat,
    ESocialNetworks.skype,
    ESocialNetworks.soundcloud,
    ESocialNetworks.threads,
    ESocialNetworks.linktree,
    ESocialNetworks.onlyfans,
    ESocialNetworks.patreon,
    ESocialNetworks.buymeacoffee,
    ESocialNetworks.deviantart,
    ESocialNetworks.artstation,
    ESocialNetworks.email,
    ESocialNetworks.phone,
];

export const ICON_TYPES = [
    EIconType.logos,
    EIconType.round,
    EIconType.square,
    EIconType.flat,
    EIconType.grey,
    EIconType.outlined,
    EIconType.outlined_white,
    EIconType.white,
];

export const SocialNetworksNames = {
    [ESocialNetworks.facebook]: 'Facebook',
    [ESocialNetworks.twitter]: 'Twitter',
    [ESocialNetworks.telegram]: 'Telegram',
    [ESocialNetworks.tiktok]: 'TikTok',
    [ESocialNetworks.instagram]: 'Instagram',
    [ESocialNetworks.youtube]: 'YouTube',
    [ESocialNetworks.linkedin]: 'Linkedin',
    [ESocialNetworks.messenger]: 'Messenger',
    [ESocialNetworks.viber]: 'Viber',
    [ESocialNetworks.whatsapp]: 'WhatsApp',
    [ESocialNetworks.pinterest]: 'Pinterest',
    [ESocialNetworks.medium]: 'Medium',
    [ESocialNetworks.spotify]: 'Spotify',
    [ESocialNetworks.slideshare]: 'SlideShare',
    [ESocialNetworks.tumblr]: 'Tumblr',
    [ESocialNetworks.twitch]: 'Twitch',
    [ESocialNetworks.vimeo]: 'Vimeo',
    [ESocialNetworks.snapchat]: 'Snapchat',
    [ESocialNetworks.skype]: 'Skype',
    [ESocialNetworks.soundcloud]: 'SoundCloud',
    [ESocialNetworks.threads]: 'Threads',
    [ESocialNetworks.linktree]: 'Linktree',
    [ESocialNetworks.onlyfans]: 'OnlyFans',
    [ESocialNetworks.patreon]: 'Patreon',
    [ESocialNetworks.buymeacoffee]: 'Buy me a coffee',
    [ESocialNetworks.deviantart]: 'DeviantArt',
    [ESocialNetworks.artstation]: 'ArtStation',
    [ESocialNetworks.email]: 'Email',
    [ESocialNetworks.phone]: 'Phone',
};
